import React from 'react';
import { Link } from 'react-router-dom';
import { useConfig } from '../../ConfigContextCore';
import digitalIndia from '../../assets/images/digital-india.png';
import myGovLogo from '../../assets/images/myGov.png';
import s3waasLogo from '../../assets/images/S3WaaS-Logo.png';
import nicLogo from '../../assets/images/nic-logo.svg';

const Footer = () => {
  const { visitorCount, language } = useConfig();

  const t = {
    English: {
      usefulLinks: 'Useful Links',
      sitemap: 'Sitemap',
      feedback: 'Feedback',
      disclaimer: 'Disclaimer',
      faqs: "FAQ's",
      help: 'Help',
      rti: 'Right to Information',
      terms: 'Terms And Conditions',
      policy: 'Website Policy',
      contactUs: 'Contact Us',
      address: 'Administrative Building, VSEZ, Duvvada',
      city: 'Visakhapatnam - 530049, Andhra Pradesh, India',
      email: 'Email ID',
      phone: 'Contact No',
      social: 'Social Media Links',
      visitors: 'Total Visitors',
      copyright: `© ${new Date().getFullYear()} Visakhapatnam Special Economic Zone, Government of India. All Rights Reserved.`,
      poweredBy: 'Powered by'
    },
    Hindi: {
      usefulLinks: 'त्वरित लिंक',
      sitemap: 'साइटमैप',
      feedback: 'प्रतिक्रिया',
      disclaimer: 'अस्वीकरण',
      faqs: 'सामान्य प्रश्न',
      help: 'सहायता',
      rti: 'सूचना का अधिकार',
      terms: 'नियम और शर्तें',
      policy: 'वेबसाइट नीति',
      contactUs: 'संपर्क करें',
      address: 'प्रशासनिक भवन, वीएसईजेड, दुव्वाडा',
      city: 'विशाखापत्तनम - 530049, आंध्र प्रदेश, भारत',
      email: 'ईमेल आईडी',
      phone: 'संपर्क संख्या',
      social: 'सोशल मीडिया लिंक',
      visitors: 'कुल आगंतुक',
      copyright: `© ${new Date().getFullYear()} विशाखापत्तनम विशेष आर्थिक क्षेत्र, भारत सरकार। सर्वाधिकार सुरक्षित।`,
      poweredBy: 'द्वारा संचालित'
    }
  }[language] || {
    usefulLinks: 'Useful Links',
    sitemap: 'Sitemap',
    feedback: 'Feedback',
    disclaimer: 'Disclaimer',
    faqs: "FAQ's",
    help: 'Help',
    rti: 'Right to Information',
    terms: 'Terms And Conditions',
    policy: 'Website Policy',
    contactUs: 'Contact Us',
    address: 'Administrative Building, VSEZ, Duvvada',
    city: 'Visakhapatnam - 530049, Andhra Pradesh, India',
    email: 'Email ID',
    phone: 'Contact No',
    social: 'Social Media Links',
    visitors: 'Total Visitors',
    copyright: `© ${new Date().getFullYear()} Visakhapatnam Special Economic Zone, Government of India. All Rights Reserved.`,
    poweredBy: 'Powered by'
  };

  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-col">
              <h3>{t.usefulLinks}</h3>
              <ul>
                <li><Link to="/sitemap">{t.sitemap}</Link></li>
                <li><Link to="/feedback">{t.feedback}</Link></li>
                <li><Link to="/disclaimer">{t.disclaimer}</Link></li>
                <li><Link to="/faqs">{t.faqs}</Link></li>
                <li><Link to="/helpdesk">{t.help}</Link></li>
                <li><Link to="/rti-officers">{t.rti}</Link></li>
                <li><Link to="/terms-and-conditions">{t.terms}</Link></li>
                <li><Link to="/copyright">{t.policy}</Link></li>
              </ul>
            </div>


            <div className="footer-col">
              <h3>{t.contactUs}</h3>
              <p><strong>{language === 'Hindi' ? 'विशाखापत्तनम विशेष आर्थिक क्षेत्र' : 'Visakhapatnam Special Economic Zone'}</strong></p>
              <p>{t.address}</p>
              <p>{t.city}</p>
              <p>{t.email}:- dc_vsez@yahoo.in | info_vsez@yahoo.in</p>
              <p>{t.phone}- +91-891-2708255 / 2587555</p>

              <div className="map-container" style={{ marginTop: '15px' }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3801.3251411035547!2d83.1466291!3d17.684105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a396eb006f1c4df%3A0xe54db2479e0a6d0b!2sVisakhapatnam%20Special%20Economic%20Zone!5e0!3m2!1sen!2sin!4v1710234567890!5m2!1sen!2sin"
                  width="100%" height="100" style={{ border: 0 }} allowFullScreen="" loading="lazy"></iframe>
              </div>
            </div>

            <div className="footer-col">
              <h3>{t.social}</h3>
              <div className="social-links flex gap-2">
                <a href="#instagram" className="social-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
                </a>
                <a href="#linkedin" className="social-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" /></svg>
                </a>
                <a href="#twitter" className="social-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.599 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" /></svg>
                </a>
                <a href="#youtube" className="social-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" /></svg>
                </a>
              </div>
              <p style={{ marginTop: '15px' }}>{t.visitors}: {visitorCount}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container flex justify-between align-center">
          <div>
            <p className='text-white fw-bold'>{t.copyright}</p>
            <p className='text-white fw-bold'>{t.poweredBy} <a href="https://www.finsol.ai/" target="_blank" rel="noopener noreferrer" className='text-white fw-bold'>Finsol Consultancy Private Limited</a></p>
          </div>
          <div className="footer-logos flex align-center gap-3">
            <a href="https://www.mygov.in/" target="_blank" rel="noopener noreferrer">
              <img src={myGovLogo} alt="myGovIndia" style={{ height: '40px' }} />
            </a>
            <a href="https://www.digitalindia.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src={digitalIndia} alt="Digital India" style={{ height: '40px' }} />
            </a>
            <a href="https://www.nic.in/" target="_blank" rel="noopener noreferrer">
              <img src={nicLogo} alt="NIC" style={{ height: '40px' }} />
            </a>
            <a href="https://www.s3waas.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src={s3waasLogo} alt="S3waas" style={{ height: '40px' }} />
            </a>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
